import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
const bonuses = [{
  src: 'https://cdn.magicpatterns.com/uploads/pEHGPzJ3LnKFHLiRxC4up6/mocap_cheklis_de_seguridad.png',
  title: 'Checklists de Seguridad',
  desc: 'Hojas de trabajo para que trabajes con resina de forma segura y profesional.'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/aWdB1ttKwK8ytJoY3av97D/mocap_el_arte_de_vender.png',
  title: 'El Arte de Vender',
  desc: 'Ebook digital con estrategias para vender tus piezas en resina y generar ingresos.'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/vnM5fEvnUtLgasKF9u7ZtX/mocap_lamparas.png',
  title: 'Lámparas con Resina',
  desc: 'Guía completa para crear lámparas únicas que se venden solas.'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/qHDiRsu4LoQngqbuazkn1h/mocap_moldes.png',
  title: 'Elaboración de Moldes',
  desc: 'Guía técnica para construir tus propios moldes sin gastar de más.'
}];
export function BonusSection() {
  return <section className="py-8 sm:py-14 bg-[#0a0e17] relative overflow-hidden" data-id="element-21">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[#d4a853]/5 rounded-full blur-[120px] pointer-events-none" data-id="element-22" />

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-23">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-6 sm:mb-10" data-id="element-24">
          <div className="inline-flex items-center gap-2 bg-[#d4a853]/10 border border-[#d4a853]/30 rounded-full px-4 py-1.5 mb-4" data-id="element-25">
            <Gift className="w-4 h-4 text-[#d4a853]" data-id="element-26" />
            <span className="text-[#d4a853] text-xs sm:text-sm font-semibold uppercase tracking-wider" data-id="element-27">
              Bonos de regalo
            </span>
          </div>
          <h2 className="text-2xl md:text-4xl font-bold text-white leading-tight" data-id="element-28">
            Además, te llevás estos{' '}
            <span className="text-[#d4a853]" data-id="element-29">4 bonos gratis</span>
          </h2>
          <p className="text-[#9ca3af] mt-3 text-base sm:text-lg max-w-2xl mx-auto" data-id="element-30">
            Complementos exclusivos que potencian tu aprendizaje y te ayudan a
            monetizar desde el día uno.
          </p>
        </motion.div>

        <div className="grid grid-cols-2 gap-4 sm:gap-6" data-id="element-31">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-[#111827] rounded-xl border border-[#ffffff]/5 overflow-hidden hover:border-[#d4a853]/30 transition-colors" data-id="element-32">
              <div className="aspect-[4/3] overflow-hidden bg-[#0a0e17]" data-id="element-33">
                <img src={bonus.src} alt={bonus.title} className="w-full h-full object-cover" loading="lazy" data-id="element-34" />
              </div>
              <div className="p-3 sm:p-5" data-id="element-35">
                <h3 className="text-white font-bold text-sm sm:text-lg mb-1 sm:mb-2" data-id="element-36">
                  {bonus.title}
                </h3>
                <p className="text-[#9ca3af] text-xs sm:text-sm leading-relaxed" data-id="element-37">
                  {bonus.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}